module.exports = __webpack_public_path__ + "img/post.213e4407.png";